const en = {
  app_name: "Nexstays",
  tagline: "Run your PG without the notebook",
  // auth
  login_title: "Owner login",
  phone_label: "Mobile number",
  email_label: "Email address",
  change_email: "Change email",
  check_inbox: "Check your inbox (and spam folder). The code expires in 5 minutes.",
  otp_resent: "New code sent",
  login_footer: "Only PG owners log in. Tenants get a no-login link.",
  whatsapp_number: "WhatsApp number",
  send_whatsapp_code: "Send code on WhatsApp",
  check_whatsapp: "Open WhatsApp to see your code. It expires in 10 minutes.",
  whatsapp_soon: "WhatsApp login is being set up. Please use email for now.",
  demo_phone_hint: "Demo WhatsApp number (code 123456):",
  phone_verified: "Verified via WhatsApp",
  join_requests: "Join requests",
  visits: "Visits",
  listing: "Public listing",
  listing_help: "Publish your PG so residents can find it in the Nexstays resident app and request to join.",
  publish_listing: "Show my PG in search",
  city: "City",
  locality: "Area / locality",
  pg_for: "PG for",
  amenities: "Amenities",
  contact_phone: "Contact number (optional)",
  resident_link: "Are you a resident? Log in here",
  send_otp: "Send OTP",
  otp_label: "Enter 6-digit OTP",
  verify_login: "Verify & login",
  otp_sent_to: "OTP sent to",
  change_number: "Change number",
  resend_in: "Resend in",
  resend_otp: "Resend OTP",
  demo_otp_hint: "Demo account: use code 123456",
  demo_account: "Try demo account",
  // nav
  nav_dashboard: "Overview",
  nav_beds: "Beds",
  nav_tenants: "Tenants",
  nav_rent: "Rent",
  nav_more: "More",
  // common
  save: "Save",
  cancel: "Cancel",
  delete: "Delete",
  confirm: "Confirm",
  add: "Add",
  edit: "Edit",
  back: "Back",
  next: "Next",
  done: "Done",
  search: "Search",
  all: "All",
  loading: "Loading...",
  retry: "Try again",
  optional: "optional",
  logout: "Log out",
  language: "Language",
  saved: "Saved",
  // status
  st_paid: "Paid",
  st_partial: "Part paid",
  st_pending: "Pending",
  st_overdue: "Overdue",
  bed_vacant: "Vacant",
  bed_occupied: "Occupied",
  bed_maintenance: "Maintenance",
  // onboarding
  ob_title: "Set up your PG",
  ob_step_property: "Property",
  ob_step_rooms: "Rooms & beds",
  ob_step_done: "Ready",
  property_name: "PG name",
  address: "Address",
  rent_due_day: "Rent due day of month",
  proration: "Mid-month joining",
  proration_prorated: "Charge by days",
  proration_full: "Charge full month",
  proration_help: "When a tenant joins on the 15th, charge only for the remaining days.",
  room_no: "Room no.",
  floor: "Floor",
  sharing: "Beds in room",
  rent_per_bed: "Rent per bed",
  deposit: "Deposit",
  add_room: "Add this room",
  copy_similar: "Copy to similar rooms",
  copy_count: "How many more rooms like this?",
  rooms_added: "Rooms to create",
  no_rooms_yet: "No rooms added yet. Fill the form above and tap Add.",
  create_rooms: "Create rooms",
  ob_done_title: "Your PG is ready!",
  ob_done_text: "Now add tenants to beds. Rent will be generated every month automatically.",
  go_dashboard: "Go to overview",
  // dashboard
  hello: "Namaste",
  occupancy: "Occupancy",
  beds_filled: "beds filled",
  collected: "Collected",
  pending: "Pending",
  overdue: "Overdue",
  this_month: "This month",
  of_due: "of",
  six_month_chart: "Last 6 months collection",
  due: "Due",
  overdue_list: "Overdue rent",
  no_overdue: "No overdue rent. Great job!",
  upcoming_moveouts: "Moving out soon",
  no_moveouts: "No move-outs in the next 30 days",
  remind: "Remind",
  open_complaints: "Open complaints",
  quick_add_tenant: "Add tenant",
  quick_collect: "Collect rent",
  // beds
  rooms_beds: "Rooms & beds",
  add_rooms: "Add rooms",
  room: "Room",
  bed: "Bed",
  no_rooms: "No rooms yet",
  no_rooms_text: "Add rooms to start assigning tenants.",
  tap_vacant: "Tap a vacant bed to add a tenant",
  mark_maintenance: "Mark under maintenance",
  mark_vacant: "Mark as vacant",
  delete_room: "Delete room",
  // tenants
  tenants: "Tenants",
  active: "Staying",
  moved_out: "Moved out",
  add_tenant: "Add tenant",
  no_tenants: "No tenants yet",
  no_tenants_text: "Add your first tenant to a vacant bed.",
  tenant_name: "Full name",
  select_bed: "Select bed",
  no_vacant_beds: "No vacant beds. Add rooms first.",
  monthly_rent: "Monthly rent",
  move_in_date: "Move-in date",
  expected_move_out: "Expected move-out",
  id_type: "ID type",
  id_last4: "Last 4 digits of ID",
  id_none: "Not collected",
  consent_label: "Tenant agreed to share ID details for verification",
  prorated_note: "First month will be prorated",
  joined: "Joined",
  rent_history: "Rent history",
  payments: "Payments & receipts",
  no_payments: "No payments yet",
  receipt: "Receipt",
  mark_paid: "Mark paid",
  share_link: "Share tenant link",
  share_link_help: "Tenant can see rent, receipts & menu without login. Link expires in 30 days.",
  revoke_link: "Disable old links",
  copy_link: "Copy link",
  link_copied: "Link copied",
  send_whatsapp: "Send on WhatsApp",
  whatsapp_note: "Opens WhatsApp with a ready message. You tap send.",
  edit_tenant: "Edit tenant",
  rent_change_note: "Rent change applies from next month, not this month.",
  next_rent: "New rent from",
  move_out: "Move out",
  id_details: "ID & consent",
  consent_at: "Consent recorded",
  id_doc: "ID document image",
  upload_id: "Upload ID image",
  view_id: "View",
  id_upload_off: "ID image upload is off for this property (recommended). Only ID type & last 4 digits are stored.",
  erase_data: "Erase personal data (DPDP)",
  erase_help: "Removes name, phone and ID details. Rent & receipt records stay for accounts.",
  erased: "Personal data erased",
  settlement: "Settlement",
  // rent
  collect_rent: "Collect rent",
  generate_rent: "Generate rent",
  generated: "Rent records ready",
  no_rent_records: "No rent for this month",
  no_rent_text: "Rent is created automatically on the 1st. Tap Generate to create it now.",
  amount: "Amount",
  mode: "Payment mode",
  cash: "Cash",
  upi: "UPI",
  bank: "Bank",
  deposit_adjustment: "From deposit",
  paid_on: "Paid on",
  note: "Note",
  full_amount: "Full",
  half_amount: "Half",
  balance: "Balance",
  payment_saved: "Payment saved",
  download_receipt: "Download receipt",
  prorated: "Prorated",
  days: "days",
  // move-out
  moveout_title: "Move-out & settlement",
  moveout_date: "Move-out date",
  deductions: "Deductions",
  add_deduction: "Add deduction",
  deduction_label: "Reason (e.g. damage)",
  adjust_deposit: "Adjust deposit against pending rent",
  rent_outstanding: "Pending rent",
  deposit_applied: "Deposit used for rent",
  refund: "Refund to tenant",
  still_owes: "Tenant still owes",
  confirm_moveout: "Confirm move-out",
  moveout_done: "Moved out. Bed is now free.",
  // more
  more: "More",
  food_menu: "Food menu",
  announcements: "Announcements",
  complaints: "Complaints",
  settings: "Settings",
  audit_log: "Activity log",
  breakfast: "Breakfast",
  lunch: "Lunch",
  dinner: "Dinner",
  today: "Today",
  menu_saved: "Menu saved",
  new_announcement: "New announcement",
  title: "Title",
  message: "Message",
  post: "Post",
  no_announcements: "No announcements yet",
  share_whatsapp: "Share on WhatsApp",
  new_complaint: "Log complaint",
  no_complaints: "No complaints. All good!",
  category: "Category",
  cat_electrical: "Electrical",
  cat_plumbing: "Plumbing",
  cat_food: "Food",
  cat_cleaning: "Cleaning",
  cat_wifi: "WiFi",
  cat_other: "Other",
  description: "Details",
  tenant_optional: "Tenant (optional)",
  c_open: "Open",
  c_in_progress: "In progress",
  c_resolved: "Resolved",
  start_work: "Start",
  resolve: "Resolve",
  reopen: "Reopen",
  // settings
  property_settings: "Property settings",
  id_upload_toggle: "Allow ID image upload",
  id_upload_warning: "Storing Aadhaar/ID images is a data-protection (DPDP) risk. Keep off unless required.",
  add_property: "Add another property",
  delete_property: "Delete property",
  profile: "Your profile",
  your_name: "Your name",
  email: "Email",
  privacy: "Privacy & data",
  delete_account: "Delete my account & all data",
  delete_account_help: "Type DELETE to permanently remove all your PGs, tenants and records.",
  no_activity: "No activity yet",
  pricing_note: "Pilot plan",
  language_help: "Choose the language for your app screens.",
  // public
  pub_hello: "Hi",
  pub_rent_status: "Your rent",
  pub_history: "Last 6 months",
  pub_receipts: "Your receipts",
  pub_menu_today: "Today's menu",
  pub_no_menu: "Menu not posted yet",
  pub_notices: "Notices from your PG",
  pub_invalid: "This link has expired or was disabled. Ask your PG owner for a new link.",
  pub_footer: "Shared by your PG owner via Nexstays. No login needed.",
  receipt_footer: "Receipts are an acknowledgement of rent received, not a tax invoice.",
};

export type Dict = typeof en;
export default en;
